/**
 * 简体中文
 */
export default {
  
  // 菜单路由
  route: {
    dashboard: {
      _name: '首页',
      workplace: {_name: '工作台'},
      analysis: {_name: '分析页'}
    },

    system: {
      _name: '账号管理',
      admin: {_name: '管理列表'},
      finance: {_name: '金主列表'},
      role: {_name: '角色管理'},
      user: {_name: '用户列表'},
      menu: {_name: '菜单管理'}
    },

    resource: {
      _name: '资源管理',
      class: {_name: '群组'},
      recolumn: {_name: '宝/卡列表'},
    },

    wallet: {
      _name: '钱包管理',
      currency: {_name: '货币管理'},
      transmodel: {_name: '交易模型'},
    },

    config: {
      _name: '系统设置',
      website: {_name: '系统设置'},
    },

    balance: {
      _name: '余额调整',
      index: {_name: '余额调整'},
    },

    channel: {
      _name: '通道管理',
      type: {_name: '通道类型'},
      balance: {_name: '通道查询'},
      column: {_name: '通道列表'},

    },

    transaction: {
      _name: '交易管理',
      inorder: {_name: '收款订单'},
      inlist: {_name: '收款确认'},
      outorder: {_name: '出款订单'},
      records: {_name: '资金变动'},
    },

    reconciliation: {
      _name: '对账管理',
      bussiness: {_name: '用户对账'},
      channel: {_name: '通道对账'},
      model: {_name: '匹配对账'},
      shouyi: {_name: '系统对账'},
      bankrecords: {_name: '宝/卡账单'},
    },

    tool: {
      _name: '开发工具',
      generate: {_name: '代码生成'},
    },

    form: {
      _name: '表单页面',
      basic: {_name: '基础表单'},
      advanced: {_name: '复杂表单'},
      step: {_name: '分步表单'}
    },
    list: {
      _name: '列表页面',
      basic: {_name: '基础列表'},
      advanced: {_name: '复杂列表'},
      card: {
        _name: '卡片列表',
        project: {_name: '项目列表'},
        application: {_name: '应用列表'},
        article: {_name: '文章列表'}
      }
    },
    result: {
      _name: '结果页面',
      success: {_name: '成功页'},
      fail: {_name: '失败页'}
    },
    exception: {
      _name: '异常页面',
      '403': {_name: '403'},
      '404': {_name: '404'},
      '500': {_name: '500'}
    },
    user: {
      _name: '个人设置',
      profile: {_name: '个人资料'},
      message: {_name: '我的消息'}
    },
    extension: {
      _name: '扩展组件',
      icon: {_name: '字体图标'},
      file: {_name: '文件列表'},
      printer: {_name: '打印插件'},
      excel: {_name: 'excel插件'},
      dragsort: {_name: '拖拽排序'},
      map: {_name: '地图组件'},
      player: {_name: '视频播放'},
      editor: {_name: '富文本框'},
      more: {_name: '更多组件'}
    },
    example: {
      _name: '经典实例',
      document: {_name: '案卷调整'},
      choose: {_name: '批量选择'},
    },
    'http://www.xxx.com': {_name: '获取授权'}
  },
  // 主框架
  layout: {
    home: '主页',
    header: {
      profile: '个人中心',
      password: '修改密码',
      logout: '退出登录'
    },
    footer: {
      website: '官网',
      document: '文档',
      authorization: '授权',
      copyright: 'Copyright © 2021'
    },
    logout: {
      title: '提示',
      message: '确定要退出登录吗?'
    }
  },
  // 登录界面
  login: {
    title: '管理后台',
    username: '请输入',
    password: '请输入',
    captcha: '请输入',
    remember: '记住密码',
    forget: '忘记密码',
    login: '登录',
    loading: '登录中'
  },


  // 通用
  universal:{
    startingtime:"开始时间",
    endtime:"结束时间",
    pleasechoose:"请选择",
    pleaseenter:"请输入",
    recognize: "确认",
    inquire:"查询",
    reset:"重置",
    export:"导出",
    turnon:"开启",
    closure:"关闭",
    yes:"是",
    no:"否",
    unknown: '未知',
    success: '成功',
    retreat: '撤销',
    abnormal: '异常',
    cancel: '取消',
  },
  // 首页
  home:{
    totalbalance:"总余额",
    availablebalance:"可用余额",
    freezebalance:"冻结金额",
    unsettledamount:"未结算余额",
  },
  // 清理数据
  cleandata:{
    selecttime:"选择时间",
    selectdata:"选择数据",
    option1:"[ 全部数据 ] | 谨慎选择，删除后无法恢复!!!",
    option2:"[ 收款数据 ] | 谨慎选择，删除后无法恢复!!!",
    option3:"[ 出款数据 ] | 谨慎选择，删除后无法恢复!!!",
    option4:"[ 账变数据 ] | 谨慎选择，删除后无法恢复!!!",
    warnings: "提示：请谨慎删除，操作后无法恢复！",
  },
  // 订单列表
  orderlist:{
    username:"用户名称",
    userorder:"用户订单",
    systemorder:"系统订单",
    transactiontype:"交易类型",
    channelorder:"通道订单",
    tradingstatus:"交易状态",
    transactionaccountchanges:"交易帐变",
    selectionperiod:"选择时间",
  },
  // 头部统计
  statistics:{
    today_success:"[今日成功]:",
    today_receipt:"[今日收款]:",
    unknown_orders:" [未知订单]:",
    unknown_amount:" [未知金额]:",
    service_fee:" [手续费]:",
    order_rate:" [订单费率]:",
  }
}
